import React, { useState } from "react";
import { Container, Card, CardBody, CardHeader, Row, Col, Form, FormGroup, Label, Input, Button } from "reactstrap";
import Section from './Section';


const ConfirmDeparture = () => {

     const departureDetails = {
    vesselName: "Sea Explorer",
    departureDate: "2024-12-05",
    departureTime: "08:30 AM",
    remarks: "Heading towards fishing zone Alpha.",
    vesselNumber:"IMULA0890KLT"
  };

    
  const handleConfirm = () => {
    console.log("Departure confirmed with details:", departureDetails);
    alert("Departure confirmed!");
    // Add further logic for confirmation here
  };

 const handleCancel = () => {
    alert(`Departure for ${departureDetails.vesselName} canceled.`);
    // Add logic for cancellation here
  };

  
  document.title =
    'Candidate Details | Jobcy - Job Listing Template | Themesdesign';
  return (
    <React.Fragment>
      <Section />
      <section className="section">
       <Container>
      <Card>
        <CardHeader>Vessel Departure Details</CardHeader>
        <CardBody>
          <Row>
            <Col md="6">
              <strong>Vessel Number:</strong> {departureDetails.vesselNumber}<br /><br />
              <strong>Vessel Name:</strong> {departureDetails.vesselName}
            </Col>
            <Col md="6">
               <strong>Departure Date:</strong> {departureDetails.departureDate}<br /><br />
              <strong>Departure Time:</strong> {departureDetails.departureTime}<br /><br />
              
            </Col>
          </Row>
          <Row className="mt-2">
            <Col md="6">
            <strong>Remarks:</strong> {departureDetails.remarks}
            </Col>
            <Col md="6">
             
            </Col>
          </Row>
          <div className="d-flex justify-content-between mt-4">
            <Button color="primary" onClick={handleConfirm}>
              Confirm Departure
            </Button>
            <Button color="danger" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </CardBody>
      </Card>
    </Container>
      </section>
    </React.Fragment>
  );
};

export default ConfirmDeparture;
